import React from 'react';
import { Camera, Volume2, Play, Square, Download, PlusCircle, HelpCircle } from 'lucide-react';
import { SensorStatus } from '../../core/types/sensor';

interface HeaderProps {
  status: SensorStatus;
  isStereoMode: boolean;
  isRecording: boolean;
  onToggleStereoMode: (stereo: boolean) => void;
  onNewExperiment: () => void;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onExport: () => void;
  onOpenHelp: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  status,
  isStereoMode,
  isRecording,
  onToggleStereoMode,
  onNewExperiment,
  onStartRecording,
  onStopRecording,
  onExport,
  onOpenHelp,
}) => {
  const getStatusClass = (st: SensorStatus) => {
    switch (st) {
      case 'running': return 'status-running';
      case 'degraded': return 'status-degraded';
      case 'error': return 'status-error';
      default: return 'status-idle';
    }
  };

  const getStatusLabel = (st: SensorStatus) => {
    switch (st) {
      case 'running': return '运行中 (Running)';
      case 'degraded': return '单摄降级 (Degraded)';
      case 'error': return '错误 (Error)';
      case 'configuring': return '配置中 (Configuring)';
      default: return '就绪 / 就空 (Idle)';
    }
  };

  return (
    <header className="app-header">
      <div className="header-brand">
        <div className="brand-icon">
          <Camera size={18} />
        </div>
        <div>
          <div className="brand-title">双摄颜色标记与声场同步追踪系统</div>
          <div className="brand-subtitle">dual-camera-acoustic-marker-tracker</div>
        </div>
      </div>

      <div className="header-controls">
        <span className={`status-badge ${getStatusClass(status)}`}>
          {getStatusLabel(status)}
        </span>

        <div className="mode-toggle">
          <button
            className={`mode-btn ${!isStereoMode ? 'active' : ''}`}
            onClick={() => onToggleStereoMode(false)}
          >
            单摄模式
          </button>
          <button
            className={`mode-btn ${isStereoMode ? 'active' : ''}`}
            onClick={() => onToggleStereoMode(true)}
          >
            双摄模式
          </button>
        </div>

        <button className="btn btn-outline" onClick={onNewExperiment}>
          <PlusCircle size={14} /> 新实验
        </button>

        {!isRecording ? (
          <button className="btn btn-success" onClick={onStartRecording}>
            <Play size={14} /> 开始采集
          </button>
        ) : (
          <button className="btn btn-danger" onClick={onStopRecording}>
            <Square size={14} /> 停止采集
          </button>
        )}

        <button className="btn btn-primary" onClick={onExport}>
          <Download size={14} /> 导出
        </button>

        <button className="btn btn-outline" onClick={onOpenHelp}>
          <HelpCircle size={14} /> 帮助
        </button>
      </div>
    </header>
  );
};
